import { useFormik } from 'formik'
import { Button, FormTextArea, LoadingIndicator, useModal } from '../../../../../../components'
import {
  AnotacaoType,
  ButtonType,
  showAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { observacaoSchema } from './validation/observacaoSchema'
import { AtendimentoDtoAnotacao } from '../../../../atendimento/core/_models'
import { adicionarAnotacao } from '../../../../atendimento/core/_requests'
import { FC } from 'react'
import { useT } from '_metronic/i18n/Metronici18n'

type IObservacaoModal = {
  atendimentoId: number
}
export const ObservacaoModal: FC<IObservacaoModal> = ({ atendimentoId }) => {
  const { closeModal } = useModal()
  const { t } = useT()
  const formik = useFormik({
    validationSchema: observacaoSchema,
    initialValues: { observacao: '' },
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const data: AtendimentoDtoAnotacao = {
          tipo: AnotacaoType.Observacao,
          anotacao: values.observacao,
        }
        await adicionarAnotacao(atendimentoId, data)
        await showAlert({
          title: 'Sucesso',
          text: 'Observação adicionado com sucesso!',
          icon: 'success',
        })
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })
  return (
    <form onSubmit={formik.handleSubmit}>
      <FormTextArea
        name='observacao'
        formik={formik}
        placeholder='Digite a observação'
        label='Observação'
        infoText='A observação será mostrada ao médico no início do atendimento'
        className='mb-3'
        isRequired
      />
      <div className='d-flex flex-end'>
        <Button type={ButtonType.Submit} className='btn-primary'>
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.send')}
        </Button>
      </div>
    </form>
  )
}
